export default __webpack_public_path__ + "static/og-c9a5ea862bad6a8053757b804d00d808.png";